import './style.scss'
import React, { useEffect, useRef, useState } from 'react'
import { getAssets } from '@/utils/apiEndpoints'
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Image,
  Input,
  Modal,
  Row,
  Space,
} from 'antd'
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  SearchOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import { AddAsset } from './AddAsset'
import { Loader } from '../Loader'
import { FileViewer } from './FileViewer'
import { Logo, TripPictureV2 } from '../TripPicture'
import { useParams } from 'react-router-dom'
import common from '@/utils/common'
import { svgImage } from '@/assets/svg/svg-icon'

export const FileSelector = ({
  onChange,
  type,
  value,
  organizationId,
  ...props
}) => {
  const imageOnly = type == 'image'
  const [loading, setLoading] = useState(false)
  const [assetList, setAssetList] = useState([])
  const [hasMoreRecords, setHasMoreRecords] = useState(true)
  const [page, setPage] = useState(0)
  const p = useParams()
  const [params, setParams] = useState({
    limit: 9,
    sortBy: 'createdAt',
    imageOnly,
    sortOrder: -1,
  })
  const loadAssets = async (pageNumber = 0) => {
    setLoading(true)
    setPage(pageNumber)
    try {
      if (params.hasOwnProperty('isArchived') && !params.isArchived)
        delete params.isArchived
      const res = await getAssets({
        ...params,
        organizationId: organizationId || p?.organization_id,
        page: pageNumber,
      })
      if (res.result.data.length > 0) {
        let aList = []
        if (pageNumber == 0) {
          aList = res.result.data
          setHasMoreRecords(true)
        } else aList = [...assetList, ...res.result.data]
        if (value && value.length > 0) {
          const ids = value.map((v) => v._id)
          aList = aList.map((a) => {
            a['selected'] = ids.includes(a._id)
            return a
          })
        }
        setAssetList(aList)
      } else setHasMoreRecords(false)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    loadAssets()
  }, [params])
  const onScroll = (x) => {
    if (
      x.target.scrollHeight - x.target.scrollTop <= x.target.clientHeight + 1 &&
      hasMoreRecords
    ) {
      loadAssets(page + 1)
    }
  }
  const onStatusChange = (asset, status) => {

    if (value.length === props.maxCount && status) {
      common.errorToast(`Maximum number of images is ${props.maxCount}.`)
      return null;
    }

    if (props.maxCount == 1) {
      if (status) onChange([asset])
      else onChange([])
    } else {
      if (status) {
        onChange([...value, asset])
      } else {
        onChange(value.filter((v) => v._id !== asset._id))
      }
    }
    const assets = JSON.parse(JSON.stringify(assetList))
    setAssetList(
      assets.map((ast) => {
        if (props.maxCount == 1) ast['selected'] = false
        if (ast._id == asset._id) ast['selected'] = status
        return ast
      }),
    )
  }
  const AssetCard = ({ asset }) => {
      // Find the index of this asset in the selected value array
      const selectedIndex = value.findIndex(v => v._id === asset._id);
      const isSelected = selectedIndex !== -1;
    return (
      <div className="attendee-card">
        <Card
          onClick={() => onStatusChange(asset, !asset.selected)}
          className={asset.selected ? 'selected' : ''}
          cover={
            asset.type && asset.type.includes('image') ? (
              <div style={{ position: 'relative' }}>
                <Image
                  alt={asset.caption}
                  src={asset.url}
                  preview={false}
                  height={150}
                />
                {asset.selected && (
                  <div style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2
                  }}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="14" cy="14" r="14" fill="#52C41A" />
                    </svg>
                    <span style={{
                      position: 'absolute',
                      color: 'white',
                      fontWeight: 700,
                      fontSize: 16,
                      left: 0,
                      right: 0,
                      textAlign: 'center',
                      top: 3
                    }}>{(value ? value.findIndex(v => v._id === asset._id) + 1 : 1)}</span>
                  </div>
                )}
              </div>
            ) : (
              <FileViewer file={asset} style={{ height: '150px' }} />
            )
          }
          shape="square"
          bordered={false}
        >
          {asset.selected ? (
            <div 
            className="selected-number-indicator"
            onClick={() => onStatusChange(asset, false)}
          >
            {selectedIndex + 1}
          </div>
          ) : (
            <CheckCircleOutlined onClick={() => onStatusChange(asset, true)} />
          )}
          <Card.Meta title={asset.caption} />
        </Card>
      </div>
    )
  }
  const clearAll = () => {
    let newAssets = JSON.parse(JSON.stringify(assetList))
    newAssets = newAssets.map((na) => {
      na['selected'] = false
      return na
    })
    setAssetList(newAssets)
    onChange([])
  }
  const onUpload = (assets) => {
    const updatedAssets = assets.map((as) => {
      as['selected'] = true
      return as
    })
    let newAssets = JSON.parse(JSON.stringify(assetList))
    newAssets = newAssets.map((na) => {
      na['selected'] = false
      return na
    })
    const finalAssets = updatedAssets.concat(newAssets)
    onChange(assets)
    setAssetList(finalAssets)
  }
  return (
    <Loader loading={loading} pageLevel={false}>
      <Row className='toolbar-file-selector-modal' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Col>
          <AddAsset
            maxCount={props.maxCount}
            type={type}
            onUpload={onUpload}
            organizationId={organizationId}
          />
        </Col>
        <Col>
          <Space>
            {value && value.length > 0 && (
              <Button
                type="link"
                style={{ color: '#20A39E', fontSize: '14px', height: '30px' }}
                onClick={() => clearAll()}
              >
                Clear All
              </Button>
            )}
            <Checkbox
              onChange={(e) =>
                setParams({ ...params, isArchived: e.target.checked })
              }
            >
              Show archived
            </Checkbox>
            <Input
              prefix={<SearchOutlined />}
              allowClear
              onChange={(e) =>
                setParams({ ...params, searchText: e.target.value })
              }
            />
            <Button
              type="link"
              icon={<SyncOutlined title="Reload" />}
              onClick={() => loadAssets(0)}
            />
          </Space>
        </Col>
      </Row>
      <div className='hr-file-selector' />
      <Divider style={{ margin: '15px 0' }} />
      <div
        className="dashboard-tripcard-row asset-library-modal"
        onScroll={onScroll}
      >
        {assetList && assetList.length > 0
          ? assetList.map((asset, index) => (
            <AssetCard asset={asset} key={index} />
          ))
          : !loading && (
            <div className="dashboard-sub-title">
              There are no asset added yet!
            </div>
          )}
      </div>
    </Loader>
  )
}

export const FileSelectorButton = ({
  maxCount = 10,
  buttonType = 'link',
  type = '',
  full = false,
  title = 'Trip header photo',
  buttonText = <>Upload</>,
  onSelect = () => { },
  selectedItems = [],
  onCancel = () => { },
  okText = 'Add photo',
  style = {},
  trip = false,
  disabled = false,
  organizationId = false,
  refLink
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState(selectedItems)

  const showModal = () => {
    setIsModalVisible(true)
    setSelectedFiles(selectedItems)
  }
  const handleOk = () => {
    setIsModalVisible(false)
    if (full) {
      onSelect(selectedFiles)
    } else onSelect(selectedFiles.map((file) => file.url))
  }
  return (
    <>
      <Button
        type={buttonType}
        disabled={disabled}
        style={{
          minWidth: '25px',
          textAlign: 'center',
          ...style,
        }}
        onClick={showModal}
        ref={refLink}
      >
        {buttonText}
      </Button>
      <Modal
        width={800}
        title={title}
        open={isModalVisible}
        onOk={handleOk}
        okText={`${okText} ${selectedFiles.length > 0 ? '(' + selectedFiles.length + ')' : ''
          }`}
        destroyOnClose={true}
        onCancel={() => {
          onCancel()
          setIsModalVisible(false)
        }}
        className='trip-header-modal'
        cancelButtonProps={{ size: 'large' }}
        okButtonProps={{
          disabled: selectedFiles.length == 0,
          size: 'large',
        }}
      >
        <FileSelector
          onChange={setSelectedFiles}
          value={selectedFiles}
          type={type}
          maxCount={maxCount}
          organizationId={trip ? trip.organizationId : organizationId}
        />
      </Modal>
    </>
  )
}

export const FileSelectorFormItem = ({
  value,
  onChange,
  showPreview = true,
  type = 'banner',
  trip = false,
  setChangeLogoRef
}) => {
  const FileSelectorButtonClick = useRef(null);

  useEffect(() => {
    setChangeLogoRef && setChangeLogoRef(FileSelectorButtonClick);
  }, [])

  return (
    <div>
      <FileSelectorButton
        type="image"
        maxCount={1}
        buttonType="default"
        onSelect={onChange}
        trip={trip}
        style={{ display: "none" }}
        refLink={FileSelectorButtonClick}
      />
      {value?.length > 0 && showPreview ? (
        <>
          {type === 'banner' ? (
            <div className="image-container">
              <TripPictureV2
                trip={{ pictureUrls: value }}
                preview={false}
                width="330px"
                height="330px"
              />
              <div className="icon-container" onClick={() => FileSelectorButtonClick.current.click()}>
                {svgImage.imagePreviewAddButton}
              </div>
            </div>
          ) : (
            <div className='image-container'>
              <Logo url={value} />
            </div>
          )}
        </>
      ) : (
        <div className='image-container'>
          <img className='image' src={svgImage.imageNotFound404}></img>
          <div className="icon-container" onClick={() => FileSelectorButtonClick.current.click()}>
            {svgImage.imagePreviewAddButton}
          </div>
        </div>
      )}
    </div>
  );
}